// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"c88f6d3b","506":"5abbd937"}[chunkId] + ".css";
};